import React from "react";
import { Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const pickerSx = {
  width: { xs: "100%", sm: 145 },
  minWidth: 132,
  backgroundColor: "#111",
  borderRadius: "8px",
  "& .MuiInputBase-root": {
    height: 46,
    color: "#fff",
    fontSize: 13,
    fontFamily: "Outfit",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.18)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(42, 245, 152, 0.55)",
  },
  "& .MuiSvgIcon-root": {
    color: "#2AF598",
  },
  "& .MuiInputBase-input": {
    py: 0,
  },
};

const FundsInlineDateRange = ({ startDate, endDate, onStartDateChange, onEndDateChange, resetKey = 0 }) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Box
      sx={{
        display: "flex",
        gap: 0.75,
        flexWrap: "nowrap",
        alignItems: "center",
        p: 0.5,
        borderRadius: "10px",
        border: "1px solid rgba(42, 245, 152, 0.12)",
        bgcolor: "rgba(0, 0, 0, 0.18)",
      }}
    >
      <DatePicker
        key={`start-${resetKey}`}
        format="DD/MM/YYYY"
        value={startDate}
        onChange={onStartDateChange}
        maxDate={endDate || undefined}
        slotProps={{
          textField: {
            size: "small",
            placeholder: "From",
            sx: pickerSx,
          },
        }}
      />
      <Box sx={{ color: "text.disabled", fontSize: 12, px: 0.25, userSelect: "none" }}>
        -
      </Box>
      <DatePicker
        key={`end-${resetKey}`}
        format="DD/MM/YYYY"
        value={endDate}
        onChange={onEndDateChange}
        minDate={startDate || undefined}
        slotProps={{
          textField: {
            size: "small",
            placeholder: "To",
            sx: pickerSx,
          },
        }}
      />
    </Box>
  </LocalizationProvider>
);

export default FundsInlineDateRange;
